import { Provider } from 'react-redux'

import { storeModel } from '@shared/store'

export const withRedux = (component) => () => (
  <Provider store={storeModel}>{component()}</Provider>
)
